import { render, staticRenderFns } from "./SubsidyStudent.vue?vue&type=template&id=6c3b3065&scoped=true"
import script from "./SubsidyStudent.vue?vue&type=script&lang=js"
export * from "./SubsidyStudent.vue?vue&type=script&lang=js"
import style0 from "./SubsidyStudent.vue?vue&type=style&index=0&id=6c3b3065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b3065",
  null
  
)

export default component.exports